// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3lA41","author":"Table_author__G9Nsu","authorImage":"Table_authorImage__1Y4MK","unreadRow":"Table_unreadRow__2PECQ"};